<template>
    <div style="font-size: 23.4375px;">
        <van-nav-bar id="reset" fixed :title="$route.name" @click-left="onClickLeft" @click-right="searchIcon()"
                     style="background-color: rgba(6,193,174,1);height: 3rem" :aria-label="$route.name">
<!--            <template #left>-->
<!--                &lt;!&ndash;            <van-icon class="hover-color" name="arrow-left" role="button" aria-label=""/>&ndash;&gt;-->
<!--                <van-icon :class="` nav-icon2 ${iconSwitch? 'nav-icon-after2' : ''}`" :name="iconSwitch? 'cross' : 'wap-nav'" role="button" size="28" aria-label="菜单" color="#4d4d4d"/>-->
<!--            </template>-->
            <template #right>
                <van-icon name="search" size="28" role="button" aria-label="搜索" color="#FFF"/>
            </template>
        </van-nav-bar>

        <div v-if="searchBox" class="search-box">
            <div class="searchBox-center">
                <div><van-icon class="search-icon" name="search" /></div>
                <div><input type="text" placeholder="搜索" @keyup.enter="submit"></div>
                <div @click="onCancel">取消</div>
            </div>
            <div style="height: 1px;width: 100%;background-color: #eee"></div>
        </div>
    </div>

</template>

<script>
    import Vue from 'vue';
    import {Button, Field, Icon, Notify, Toast,Search } from 'vant';
    Vue.use(Field).use(Button).use(Notify);
    Vue.use(Search);
    Vue.use(Icon);
    export default {
        components:{},
        data() {
            return {
                iconSwitch:false,
                searchBox:false,
                value:''
            }
        },
        props: {
            name: {},
            pro:{},

        },
        methods: {
            submit(e){
                if(this.pro==0){
                    this.$router.push("/Ahome?type=0&proname="+e.target.value)
                }else if(this.pro==1){
                    this.$router.push("/Aproduce?type=0&proname="+e.target.value)
                }else if(this.pro==2){
                    this.$router.push("/Aproblemdetail?type=0&problemName="+e.target.value)
                }
                this.searchBox = false
            },
            onClickLeft(){
                this.iconSwitch = !this.iconSwitch
            },
            onClickRight(){
            },
            // onSearch(val) {
            //     Toast(val);
            // },
            searchIcon(){
                this.searchBox = true
            },
            onCancel() {
                this.searchBox = false
            },

        }
    }
</script>

<style scoped>
    .nav-icon2{
        transition:transform .6s;
        -webkit-transition:transform .6s
    }
    .nav-icon-after2{
        transform: rotate(360deg);
    }
    #reset /deep/ .van-ellipsis{
        color: #fff !important;
        font-size:1.2rem;
        font-weight:500;
    }

    /*搜索*/
    .search-box{
        width: 100%;
        height: 100vh;
        background-color: #fff;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999;
    }
    .search-box .searchBox-center{
        width: 88vw;
        height: 52px;
        background-color: #fff;
        margin: 10px auto;
        line-height: 52px;
        display: flex;
    }
    .search-box .searchBox-center div:first-child{
        /*margin-right: 20px;*/
    }
    .search-box .searchBox-center div:nth-child(2) input{
        display: block;
        width: 60vw;
        font-size: 20px;
        border: none;
        padding: 0;
        margin: 0;
    }
    .search-box .searchBox-center input::-webkit-input-placeholder{
        color: #bbb;
    }
    .search-box .searchBox-center div:nth-child(3){
        width: 100%;
        text-align: right;
        font-size: 20px;
    }
    .search-icon{
        font-size: 28px;
        color: #868686;
        line-height: 52px;
        margin-right: 20px;
    }

</style>
